import loadable from '@loadable/component';

export default loadable(
    () => import(/* webpackChunkName: "ShippingAndReturnsIrisLazy" */ './ShippingAndReturnsIris'),
    {
        fallback: null,
    }
);
